
import { useParams } from 'react-router-dom';

import { useI18n } from 'src/utils/lni18n';
import coursePartService, { onePartatom } from '../CoursePartService';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useAtom } from 'jotai';
import LnIcon from 'src/components/LnIcon';
import { IdAndNameAndSelectDto } from 'src/types';
import { CoursePartHiddenTests } from '../domain/PublishPartViewDataDTO';
import { AlertDialog } from 'src/components/Modalservice/AlertDialog';
import UsedBy from './UsedBy';
import { useConfirm } from 'src/components/Modalservice/UseConfirm';


export type ClassAndTest = {
    Id: string,
    Name: string,
    Tests: IdAndNameAndSelectDto[];
}


export default function Publish() {

    const { partId } = useParams();
    const { languageService: t } = useI18n();
    const confirm = useConfirm();
    const dialog = useRef<HTMLDialogElement | null>(null);

    const partAtom = useMemo(() => onePartatom(partId!), [partId]);
    const [partData] = useAtom(partAtom);

    const part = partData.Data;
    const publishData = part?.PublishData;


    const [excludedTestClasses, setExcludedTestClasses] = useState<ClassAndTest[] | undefined>(
        part?.PublishData.Classes.map(c => ({ Id: c.Id, Name: c.Name, Tests: part.NewTests.map(t => ({ Id: t.Id, Name: t.Name, Dirty: false })) })));

    const checkExcluded = (state: boolean, classId: string, test: IdAndNameAndSelectDto) => {
        setExcludedTestClasses(te => {
            if (te == null) return te;
            const classData = te?.find(cl => cl.Id === classId);
            if (!classData) return te;
            const testToChange = classData.Tests.find(te => te.Id === test.Id);
            if (testToChange) {
                testToChange.Selected = state;
            }

            return te;
        })
    }

    const doPublish = useCallback(async () => {

        let hiddenTests: CoursePartHiddenTests[] = [];
        if (excludedTestClasses && excludedTestClasses.length > 0) {
            hiddenTests = excludedTestClasses.map(cl => ({

                StudentClassId: cl.Id,

                TestIds: cl.Tests
                    .filter(te => te.Selected === true)
                    .map(te => te.Id)
            }))

                .filter(cl => cl.TestIds.length > 0);
        }


        const response = await coursePartService.publishPartRequest(partId!);
        if (!response) return;
        if (response.Result) {
            const result = await confirm("md", t.getText("publish"),
                    <div className="preserve-white" >{response.Message}</div> );

            if (result === true) {
                if (response.Async) {
                    coursePartService.publishPart(partId!, hiddenTests);
                }
                else {

                    if (dialog.current) {
                        dialog.current.showModal();
                    }

                    // do the publish thing
                    try {
                        await coursePartService.publishPart(partId!, hiddenTests);
                    } finally {
                        if (dialog.current) {
                            dialog.current.close();
                        }
                    }


                }
            }
        }

    }, [excludedTestClasses, partId, t, confirm]);

    return <>

        <div className="d-flex mb-3">

            <h3 className="flex-fill">{t.getText("publish")}</h3>
            <div className="ml-auto d-flex align-items-center">
                {partData?.Data?.Dirty && <LnIcon name="alert" className='mr-3' />}
                {!partData.Data?.Locked &&
                    <button disabled={!partData?.Data?.Dirty} onClick={doPublish} className="btn btn-primary">{t.getText("publish")}</button>
                }
            </div>

        </div>
        <div className='d-flex mb-3'>
            <div className='ml-auto pr-4'>
                {partData?.Data?.Dirty && <span >{t.getText("courspart.not.published")}</span>}
                {!partData?.Data?.Dirty && <span >{t.getText("published")}</span>}
            </div>
        </div>

        {publishData && <UsedBy publishData={publishData} checkExcluded={checkExcluded} part={part} excludedTestClasses={excludedTestClasses} />}

        <dialog ref={dialog} className="md">
            <AlertDialog 
                title={t.getText("publish")}   
                languageService={t}
                message={t.getText("publishing")}
                className=""
                onSubmit={(d) => { }}
                noButton={true} />
        </dialog>

    </>



}